import { StringsType } from "./en"

export const ja: StringsType = {
  bubbleExpiration: {
    expiredTitle: "無料Premiumの有効期限が切れました",
    expiredSubtitle: "最高のPhotoVault体験のためPremiumにアップグレード",
    expiredSubtitlePremium: "優れたPhotoVault体験のためPremiumにアップグレード",
    expiredSubtitleUltimate:
      "最高のPhotoVault体験のためUltimateにアップグレード",
    trashRecovery: "ゴミ箱の復元",
    cloudVault: "Cloud Vault",
    spaceSaver: "Space Saver",
    noAds: "広告なし",
    everyPremiumFeature: "すべてのPremium機能を\n取得",
    everyUltimateFeature: "すべてのUltimate機能を\n取得",
    unlockUltimateTools:
      "アプリのすべてのプライバシーツールのロックを解除します。",
    cloudVaultUltimate: "Cloud Vault - 1,000 GB",
    organizationPlus: "整理+",
    organizationPlusDesc: "サブアルバムの作成、重複の検索などが可能です。",
    perMonth: "月額",
    perYear: "年額",
    justOnce: "一度だけ",
    lifetime: "生涯",
    threeMonths: "3ヶ月",
    lifetimeTitle: "生涯プラン",
    lifetimeDescription:
      "生涯プランは近日公開予定です。アップデートをお楽しみに！",
    lifetimeFeature1: "一回払い",
    lifetimeFeature2: "すべての機能への生涯アクセス",
    lifetimeFeature3: "長期ユーザーに最適な価値",
    lifetimeCta: "Lifetimeを購入",
    lifetimeSheetDisclaimer: "クラウドバックアップ（50GB）を5年間含む。",
    lifetimeSheetDisclaimerDetailed:
      "ライフタイムプランには5年間のCloud Vaultバックアップ（50 GB）が含まれています。その後、ライフタイムメンバーのみ利用可能な割引Cloud Vaultサブスクリプションを利用できます。すべてのプレミアム機能は追加料金なしで常に利用可能です。",
    lifetimeDisclaimerCloudStorage:
      "ライフタイムプランには5年間のCloud Vaultバックアップ（50 GB）が含まれています。",
    lifetimeDisclaimerAfterPeriod:
      "5年後、ライフタイムメンバーのみ利用可能な割引Cloud Vaultサブスクリプションを利用できます。",
    lifetimeDisclaimerPremiumFeatures:
      "すべてのプレミアム機能は追加料金なしで常に利用可能です。",
    monthly: "月額",
    yearly: "年額",
    selectPlan: "継続するプランを選択してください",
    unlockPrivacyTools: "優秀なプライバシーツールをアンロック。",
    cloudVaultGB: "Cloud Vault - 50 GB",
    secureBackups: "暗号化されたままの安全なバックアップ。",
    freeUpSpace: "携帯電話のスペースを解放します。",
    recoverDeleted: "ゴミ箱から削除されたアイテムを復元します。",
    fullExperience: "中断のない完全な体験。",
    restorePurchases: "購入を復元",
    basicTitle: "Private Photo Vault Basic",
    free: "無料",
    basicDescription:
      "BasicはPhotoVaultの無料版です。PINスクリーンの背後で重要な写真を保護し、優れたプライバシー機能を提供します。",
    switchToBasic: "Basicに切り替え",
    termsOfService: "利用規約",
    privacy: "プライバシー",
    switchToPremium: "Premiumに切り替える",
    switchToUltimate: "Ultimateに切り替える",
    premiumExpiredTitle: "Premiumの有効期限が切れました",
    ultimateExpiredTitle: "Ultimateの有効期限が切れました",
    renewSubtitle: "最高のPrivate Photo Vault体験のために更新してください",
    selectPlanOrSwitchToPro:
      "プランを選択するか、無料でProに切り替えてください",
    selectPlanOrSwitchToBasic:
      "プランを選択するか、無料でBasicに切り替えてください",
    proTitle: "Private Photo Vault - Pro",
    purchased: "購入済み",
    proDescription:
      "以前に買い切り版のProを購入されているため、以前お支払いいただいたすべてのPro機能を引き続きご利用いただけます。",
    switchToPro: "Proに切り替える",
    subscribeFor: (price: string) => `${price}/年で登録`,
    subscribeForMonth: (price: string) => `${price}/月で登録`,
    billedPerYear: (price: string) => `年額${price}で請求`,
    oneStepSubtitle:
      "最高のPrivate Photo Vault体験のために\nプレミアムにアップグレード",
    oneStepSubtitleUltimate:
      "最高のPrivate Photo Vault体験のために\nアルティメットにアップグレード",
    purchaseWithAppStore: "App Storeで購入",
  },
  title: "全機能への無制限のアクセス",
  freeTrial: "無料おためし",
  startPlan: "プランを開始します",
  pricePerMonth: (price: any) => `${price}/月`,
  pricePerYear: (price: any) => `${price}/年で請求`,
  freeTrialDescriptionYearly: (days: number, price: string) =>
    `${days}日間無料、その後${price}/年。いつでもキャンセル可能`,
  freeTrialDescriptionMonthly: (days: number, price: string) =>
    `${days}日間無料、その後${price}/月。いつでもキャンセル可能`,
  discount: (discount: number) => `${discount}% オフ`,
  new: "新しい",
  trashRecovery: "ごみ箱の復元",
  adFree: "広告なしの体験",
  breakIn: "侵入レポート： 写真とGPS",
  wireless: "ワイヤレスで写真を転送",
  decoy: "おとり用パスコード",
  pattern: "パターンロック",
  appDisguise: "アプリの偽装",
  comingSoon: "近日発売",
  subscriptionTerms: "購読期間:",
  terms:
    "支払いは購入確認時にiTunesアカウントに課金されます。購読は、自動更新が少なくとも現在の期間終了24時間までにオフにしない限り自動的に更新されます。アカウントは現在の期間終了前の24時間以内に更新が課金されます。購入後、Acccouint Settings（アカウント設定）に行って購読を管理し、自動更新をオフにできます。",
  privacy: "プライバシー",
  alreadyPurchased: "すでに購入済みですか?",
  termsButton: "規約",
  monthly: "毎月",
  yearly: "毎年",
  popular: "人気",
  save: (discount) => `${discount}% OFF`,
  anniversaryTitle: (discount) => `記念日セール - ${discount}% OFF`,
  blackFridayTitle: (discount) => `ブラックフライデー - ${discount}% OFF`,
  year: "年",
  years: "年",
  hour: "時間",
  hours: "時間",
  minute: "分",
  minutes: "分",
  second: "秒",
  seconds: "秒",
  promoSubtitle: (hours) =>
    `急いでください、このセールは${hours}時間しか続きません`,
  offerExpires: "オファーの有効期限まで",
  unlockDeal: "ディールをアンロック",
  blackFridayPaywallTitle: "ブラックフライデーディール",
  anniversaryPaywallTitle: "あなたの記念日のオファー 🎉",
  blackFridayPaywallSubtitle:
    "ブラックフライデーのこの一回限りのオファーをお見逃しなく！アノアルサブスクリプションで大幅な割引を手に入れましょう。",
  anniversaryPaywallSubtitle: (years: number, discount: number) =>
    `おめでとうございます、${years} 年間のご愛顧！お祝いに、プレミアムで ${discount}% の割引をご利用いただけます。忠誠心に感謝いたします！`,
  blackFridayAnnualTitle: "あなたのブラックフライデーオファー 🎉",
  anniversaryAnnualTitle: "あなたの記念日のオファー 🎉",
  oneYear: "1 年",
  oneMonth: "1 か月",
  lockedIn: "この年間価格は永遠にロックされます",
  subtitleFixed: "急いで、このセールはもうすぐ終了します",
  importTitle: "ボールトを始めよう",
  importSubtitle: "それは100％プライベートです！",
  importInfo: "隠して安全に保管したい写真や動画を追加しましょう。",
  importCTA: "ボールトに追加",
  skip: "スキップ",
  totalMonthsPrice: (price: string) => `12ヶ月 • ${price}`,
  monthlyPrice: (price: string) => `${price} / 月`,
  oneTimeOffer: {
    title: "あなたの一回限りのオファー",
    subTitle: "一回限りのオファーを閉じると、それはなくなります！",
    claim: "あなたの一回限りのオファーを請求する",
  },
  returnOffer: {
    monthly: (price: string) => `${price}/月として低い`,
    title: "あなたの独占的な再開オファー",
    subTitle: "今日特別料金で会員資格を再活性化！限定時間のみ利用可能",
    discountTitle: "特別割引",
    cta: "今すぐ再開",
    discountSubTitle: "期間限定オファー",
  },
  off: "オフ",
  special: "スペシャル",
  yearlyPlan: "年間プラン",
  monthlyPlan: "月間プラン",
  subscribe: "サブスクライブ",
  cancelAnytime: "いつでもキャンセル可能",
  freeTrialPaywall: {
    title: "無料トライアルのご利用方法",
    firstStep: {
      title: "今すぐ",
      subtitle:
        "プライベートフォトボルトへの無制限アクセスを解除し、誰にもあなたのプライベート写真を見られる心配をしなくて済むようにします",
    },
    secondStep: {
      title: "今日: 無料トライアルを開始",
      subtitle:
        "フォトボルトへの完全アクセスを解除します。今日は料金が発生しません。",
    },
    thirdStep: {
      title: "7日後",
      subtitle:
        "この日に料金が発生します。それまでにキャンセルすれば料金は発生しません。",
    },
    whatsIncluded: "含まれる内容を確認する",
    viewAllPlans: "すべてのプランを表示",
    startTrial: "無料トライアルを開始",
    footerTitle: (yearlyPrice: string, monthlyPrice: string) =>
      `7日間無料、その後は${yearlyPrice}/年\n（月額${monthlyPrice}）`,
    footerDisclaimer:
      "トライアル終了前にいつでもキャンセル可能です。7日後にのみ料金が発生します",
    featureList: {
      title: "プライベートフォトボルトとは？",
      infoTitle: "100% プライベートかつ安全",
      infoSubtitle: "データを保護し、不正アクセスを防止",
      subTitle: "プレミアムにアップグレードしてアクセスする内容：",
    },
    comparePlans: {
      ultimateYearly: "Ultimate 年間プラン",
      monthly: "月額",
      yearly: "年額",
      threeMonths: "3か月",
      freeFor: (days: number) => `${days}日間無料`,
      monthlyPrice: (price: string) => `月額${price}のみ`,
      dailyPrice: (price: string) => `1日あたり${price}のみ`,
      cta: "続行",
    },
  },
  comparePlans: {
    title: "プランを比較",
    compare: "比較",
    freeTitle: "無料",
    basicTitle: "ベーシック",
    premiumTitle: "Premium",
    ultimateTitle: "Ultimate",
    unlockPremium: "Premium を解除",
    unlockUltimate: "Ultimate を解除",
    choose: "プランを選択",
  },
  features: {
    organizationPlus: "整理+",
    securityPlus: "セキュリティ+",
    duplicateDetection: "重複検出",
    faceDownLock: "画面を下向きにしてロック",
    customIcons: "カスタムアイコン",
    encryptedStorage: "暗号化されたフォトストレージ",
    unlimitedAlbums: "無制限のアルバム",
    browser: "セキュアなウェブブラウザ",
    camera: "プライベートカメラ",
    subalbums: {
      title: "サブアルバム",
      description:
        "複数レベルのサブアルバムを作成して、コンテンツを効率的に整理します。",
    },
    filteringAndSearching: {
      title: "フィルタリングと検索",
      description:
        "アルバムを検索し、フィルターを適用して特定のコンテンツタイプを見つけます。",
    },
    alphanumericPasscode: {
      title: "英数字のパスコード",
      description:
        "英数字のパスワードを使用して、アプリのセキュリティを強化します。",
    },
    dualLock: {
      title: "パスコード + Face ID が必要",
      description:
        "追加のセキュリティのため、アプリに入るたびにパスコードとFace IDの両方が必要です。",
    },
    locationBasedLock: {
      title: "位置情報ベースのロック",
      description: "承認されたGPS位置でのみアプリのロック解除を許可します。",
    },
  },
  gotIt: "了解しました!",
  promo: {
    premiumSave: (percent: string) => `PREMIUMで${percent}%節約`,
    monthly: (price: string) => `月額${price}のみ`,
    yearly: (price: string) => `年間${price}`,
    limited: "残り時間が限られています",
    claimOffer: "オファーを取得",
    seconds: (count: number) => (count == 1 ? "秒" : "秒"),
    minutes: (count: number) => (count == 1 ? "分" : "分"),
    oneTimeOffer: "一度限りのオファー",
    normalFee: "通常料金",
    backTo: "に戻る",
    yearlyShort: (price: string) => `年間${price}`,
  },
  premiumToUltimateBlackFriday: {
    title: "ブラックフライデーセール",
    subTitle: "ULTIMATEにアップグレード",
    cloud: {
      title: "1,000GBのクラウドストレージ",
      description: "50万枚以上の写真を安全に保管",
    },
    duplicateDetection: {
      description: "重複画像を見つけて削除",
    },
    organizationPlus: {
      description: "サブアルバムを作成、写真をフィルタリングおよび検索",
    },
    securityPlus: {
      description: "英数字パスコード、位置情報ロックなどでセキュリティ強化",
    },
    timeRemaining: "残り時間",
    saleBanner: "期間限定メガセール",
    saleTitle: "ブラックフライデーセール 🎉",
    bannerTitle: (discount: number) => `ブラックフライデー ${discount}% オフ`,
    bannerCTA: "オファーを受け取る",
    monthPrefix: "12か月 • ",
    perMonthPrice(price: string) {
      return `${price} / 月`
    },
    monthly: "月額",
    ultimateLaunch: {
      title: "Ultimateにアップグレード",
      saleTitle: "Ultimateローンチセール 🚀",
      bannerTitle: (discount) => `Ultimateローンチ - ${discount}%節約`,
    },
  },
  blackFridayNoFeatures: {
    title: "BLACK FRIDAY",
    lessThanCoffee: "コーヒーより安い。",
    dontWait: "待たないで！このオファーはすぐになくなります",
    whatWaiting: "何を待っているの？",
    claimOffer: "限定オファーを受け取る",
    moneyBack: "返金保証",
  },
  cyberMonday: {
    title: "CYBER MONDAY",
    subTitle: "Ultimateを手に入れよう",
    cloud: {
      title: "1,000GBクラウドストレージ",
      description: "50万枚以上の写真のための安全なクラウドストレージ",
    },
    duplicateDetection: {
      description: "重複した画像を見つけて削除",
    },
    organizationPlus: {
      description: "サブアルバムの作成、フィルタリング、写真の検索",
    },
    securityPlus: {
      description:
        "英数字パスコード、位置情報ベースのロックなど、強化されたセキュリティ",
    },
    timeRemaining: "残り時間",
    saleBanner: "期間限定サイバーセール",
    saleTitle: "サイバーマンデーセール",
    bannerTitle: (discount: number) => `サイバーマンデー ${discount}%オフ`,
    bannerCTA: "オファーを受け取る",
    monthPrefix: "12ヶ月 • ",
    perMonthPrice(price: string) {
      return `${price} / 月`
    },
    monthly: "月額",
    ultimateLaunch: {
      title: "Ultimateにアップグレード",
      saleTitle: "Ultimateローンチセール",
      bannerTitle: (discount: number) =>
        `Ultimateにアップグレード - ${discount}%節約`,
    },
  },
  beforeYouGo: {
    title: "ちょっと待って - 去る前に",
    subtitle: "あなたの写真を安全かつプライベートに保つ",
    subtitle2: "プレミアムを7日間完全に無料で。",
    cta: "無料トライアルを開始",
    cancelTitle:
      "試用期間が終了する前にいつでもキャンセル可能で、7日間経過するまで料金は発生しません。",
    skipCta: "結構です",
  },
  enableTrial: "まだ迷っていますか？ 無料トライアルを有効にする",
  startTrial: "無料トライアルを開始",
  trialActivated: (days) => `${days}日間のトライアルが有効化されました`,
  specialOffer: {
    enabledTitle: "特別オファーが有効になりました",
    trialTitle: "7日間の無料トライアルを獲得しよう",
    expirationTitle: "まもなくサブスクリプションが終了します！",
    expirationSubtitle: "特別価格で更新しましょう！",
    priceBoxExpiration: {
      title: "特別更新オファー",
      offerName: "年間プラン",
      ctaTitle: "特別オファーを受け取る",
    },
    priceBoxTrial: {
      title: "限定：7日間の無料トライアルを追加提供",
      offerName: "7日間の追加トライアル",
      ctaTitle: "無料トライアルを受け取る",
    },
  },
  premiumToUltimate: {
    titleLine1: "ULTIMATEへのアップグレード",
    titleLine2: "一度限りのオファー",
    megaSaleBanner: "期間限定メガセール",
    upgradeTitle: "Ultimateアップグレードセール",
    yearlySubtitlePrefix: "12か月 •",
    monthlyPriceSuffix: "/ 月",
  },
  monthlyToYearly: {
    titleLine1: "年間プランへのアップグレード",
    titleLine2: "一度限りのオファー",
    subtitleWarning: "この一度限りのオファーを閉じると、もう利用できません！",
    specialLabel: "特別",
    offerTitle: "一度限りのオファーを利用する",
    offerName: "年間プラン",
    subscribeButton: "登録する",
    cancelAnytime: "いつでもキャンセル可能",
    yearlySubtitlePrefix: "12か月 •",
    monthlyPriceSuffix: "/ 月",
  },
  expiration: {
    warmup: {
      close: "閉じる",
      subtitle:
        "携帯電話を紛失または盗難された場合でも、写真を安全かつ復元可能に保ちましょう",
      features: {
        cloudVault: {
          title: "Cloud Vault",
          subtitle: "ファイルの暗号化バックアップ",
        },
        cloudVaultUltimate: {
          title: "Cloud Vault",
          subtitle: "1,000GBのCloud Vaultストレージ",
        },
        reviews: {
          title: "50万以上の★5レビュー",
          subtitle: "何百万人に信頼されています",
        },
        noAds: {
          title: "広告なし",
          subtitle: "広告のない体験",
        },
        organizationPlus: {
          title: "Organization+",
          subtitle: "サブアルバム、高度なフィルターなど",
        },
      },
      footer: "そしてすべての機能！",
      switchToPremium: "Premiumに切り替える",
      switchToUltimate: "Ultimateに切り替える",
      titlePremium: "Premiumの有効期限が切れました！",
      titleUltimate: "Ultimateの有効期限が切れました！",
      popular: "人気",
      perMonth: "月額",
      perYear: "年額",
    },
    titlePremium: "Premiumの有効期限が切れました",
    titleUltimate: "Ultimateの有効期限が切れました",
    subtitlePremium:
      "Premiumを更新してすべての機能を保持するか、無料でBasicに切り替えてください",
    subtitleUltimate:
      "Ultimateを更新してすべての機能を保持するか、無料でBasicに切り替えてください",
    basicButton: "Basicに切り替える",
    basicTitle: "Basicとは？",
    basicDescription:
      "Basicはアプリの無料版です。写真や動画はPINで保護できますが、Cloud Vaultの暗号化バックアップや他のPremium機能は使えなくなります",
  },
  animated: {
    title: "プランを選択",
    yearlyPrice: (price: string) => `年額わずか${price}`,
    subtitle: "自動更新。いつでもキャンセル可能",
    cta: "続ける",
    trial: "無料トライアル有効化済み",
    breakinShort: "侵入レポート",
    unlimitedPhotos: "無制限の写真",
  },
  choosePlanTitle: "プランを選択",
  socialProof: {
    titleWithTrial: "Private Photo Vaultを試す\n7日間無料",
    title: "Private Photo Vaultを試す",
    continueForFree: "無料で続ける",
    continue: "続ける",
    cancelAnytime: "いつでもキャンセル可能",
    mostPopular: "一番人気",
    twelveMonths: "12ヶ月",
    oneMonth: "1ヶ月",
    yearlySubtitle: (monthlyPrice: string, yearlyPrice: string) =>
      `${monthlyPrice}/月、${yearlyPrice}/年として請求`,
    monthlySubtitle: (price: string) => `${price}/月`,
  },
  yearlyOnlyAppStore: {
    yearly: "年間",
    billedYearly: (price: string) => `${price} 年額請求`,
    perMonth: (price: string) => `${price}/月`,
    startTrial: (days: number) => `${days}日間の無料トライアルを開始`,
    purchaseWithAppStore: "App Storeで購入  (トライアルなし)",
    purchaseImmediately: "今すぐ購入  (トライアルなし)",
  },
  multistep: {
    lockTitle: "プライベート写真をロック",
    subtitle: {
      line1: "当社は",
      line2: "7日間無料",
      line3: "すべての人に写真を守ってもらうために提供しています",
    },
    subtitleReminder: {
      line1: "試用期間が終了する",
      line2: "2日前 ",
      line3: "にリマインダーを送信します。",
    },
    noPaymentNow: "今は支払い不要",
    startFreeWeek: "無料の1週間を開始",
    payTitle: "7日間無料",
    afterPrice: (price: string) => `その後は${price} / 月`,
    afterBilling: (price: string) => `（トライアル後は年額${price}として請求）`,
    footerTitle: (price) => `7日間無料。その後は${price}/年`,
    footerMonthlyTitle: (price) => `すぐに${price}が請求されます。`,
    headerTitle: "7日間の無料トライアル",
    anual: "年額",
    monthly: "月額",
    noTrial: "無料トライアルなし",
    yearlyPrice: (price) => `${price} / 年`,
  },
  oneTimeOfferTitle: "一度限りのオファー",
  unlockPremiumFor: "年間Premiumをアンロック：",
  oneTimeOfferSubtitle: "これは一度限りのオファーです",
  lowestPrice: "過去最安値",
  summerSale: {
    title: "サマーセール",
    tagline: "太陽はすべてを見ている...あなたの保管庫の中以外は！",
    timeRemaining: "オファー終了まであとわずか",
    limitedTimeOffer: "期間限定オファー",
    savePercent: (percent: number) => `${percent}%オフ`,
    bannerSubtitle: (price: string) => `Premiumを${price}でゲット`,
    bannerSubtitleUltimate: (price: string) => `Ultimateを${price}でゲット`,
    getPremium: "Premiumプライバシーを入手",
    getUltimate: "Ultimateプライバシーを入手",
    hours: "時間",
    minutes: "分",
    seconds: "秒",
    features: {
      premiumFeature: {
        title: "すべてのPremium機能を手に入れる",
        description: "プライバシーを保護するPremiumツール。",
      },
      cloudVault: {
        title: "Cloud Vault - 50 GB",
        description: "暗号化されたまま保たれる安全なバックアップ。",
      },
      noAds: {
        title: "広告なし",
        description: "中断のない完全な体験。",
      },
      faceDownLock: {
        title: "下向きロック",
        description: "携帯を裏返すだけでアプリをロック。",
      },
      breakInReports: {
        title: "侵入レポート",
        description: "誰かが保管庫にアクセスしようとしたらアラート。",
      },
    },
    pricing: {
      summerSale: "サマーセール",
      monthly: "月額",
      perMonth: (price: string) => `${price} / 月`,
      twelveMonths: "12ヶ月",
      originalPrice: (price: string) => price,
      discountedPrice: (price: string) => price,
    },
  },
  autumnSale: {
    title: "秋のセール",
    tagline: "葉がすべてを覆います…\nあなたの秘密も含めて！",
    buttonTitle: "秋のセール",
  },
  halloweenSale: {
    title: "ハロウィンセール",
    tagline: "夜は多くのものを隠します…\n特にあなたのものを！",
    buttonTitle: "ハロウィンセール",
  },
  winterSale: {
    title: "ウィンターセール",
    tagline: "雪の下であなたの写真を守りましょう",
    buttonTitle: "ウィンターセール",
  },
  springSale: {
    title: "スプリングセール",
    tagline: "この限定春割引でプレミアムにアップグレード",
    ultimateTagline: "この限定春割引でアルティメットにアップグレード",
    buttonTitle: "スプリングセール",
  },
  emailPromo: {
    title: "限定Premium オファー",
    upgradeButton: "Premium にアップグレード",
    yearlyTitle: "Premium 年間",
    decoyDescription: "おとりのパスワードで開く偽の金庫を作成",
  },
  tabsPaywall: {
    premiumTab: "Premium",
    ultimateTab: "Ultimate",
    premiumTitle: "Premiumをアンロックして",
    premiumTitleHighlight: "保管庫を守ろう",
    ultimateTitleStart: "",
    ultimateTitleHighlight: "Ultimate",
    ultimateTitleEnd: "をアンロックして\nすべての機能にアクセス",
    perMonth: "/月",
  },
  trialFooter: {
    freeTrialDays: (days: number) => `${days}日間\n無料トライアル`,
    noFreeTrial: "無料トライアル\nなし",
    noCommitment: "縛りなし。いつでもキャンセル可能。",
    cta: "$0で試す",
    ctaMonthly: "続ける",
    yearly: "年額",
    monthly: "月額",
  },
  onboardingUltimateAlternate: {
    title: "無料トライアルを開始",
    premiumDescription: "優れたプライバシーツールのロックを解除します。",
    ultimateDescription: "最高のPhoto Vault体験。",
    includesPremium: "Premiumを含む",
    trialPricing: (yearlyPrice: string, monthlyPrice: string) =>
      `7日間無料、その後${yearlyPrice}（${monthlyPrice}/月）`,
    timeline: {
      today: "今日：",
      todayDescription: "無料トライアルを開始",
      day5: "5日目：",
      day5Description: "リマインダーを受け取る",
      day7: "7日目：",
      day7Description: (yearlyPrice: string) => `${yearlyPrice}が請求されます`,
    },
    comparisonTable: {
      header: "取得内容",
    },
    didYouKnow: {
      label: "ご存知ですか？",
      statNumber: "3倍",
      statDescription: "サブスクライバーは3倍の安心感を得られます",
    },
    pricing: {
      yearlyPlanTitle: "年間プラン",
      yearlyPlanSubtitle: (yearlyPrice: string) => `${yearlyPrice}/年`,
      yearlyAmount: (monthlyPrice: string) => `${monthlyPrice}/月`,
      monthlyTitle: "月額",
      monthlyAmount: (monthlyPrice: string) => `${monthlyPrice}/月`,
      popularBadge: "人気",
    },
    ctaButton: "無料トライアルを開始",
  },
  threeStepExpiration: {
    premiumExpired: "Premiumの有効期限が切れました",
    ultimateExpired: "Ultimateサブスクリプションの有効期限が切れました",
    freeExpired: "無料Premiumの有効期限が切れました",
    subtitle: "アカウントがダウングレードされました。",
    subtitlePremium: "アカウントがダウングレードされました。",
    subtitleUltimate: "アカウントがダウングレードされました。",
    allPremiumFeatures: "すべてのPremium機能",
    allUltimateFeatures: "すべてのUltimate機能",
    spaceSaver: "スペースセーバー",
    disabled: "無効",
    restoreMyProtection: "フルアクセスを復元",
    seeWhatImLosing: "失うものを確認",
    photosSafeWarning: "写真は安全ですが、重要な機能が無効になっています。",
    continue: "続ける",
    heresWhatYoureLosing: "失われる機能はこちら",
    allFeaturesDisabled:
      "以下のすべてのプレミアム機能がアカウントで無効になります：",
    allFeaturesDisabledUltimate:
      "以下のすべてのアルティメット機能がアカウントで無効になります：",
    back: "戻る",
    stepOf: (current: number, total: number) => `ステップ ${current}/${total}`,
    restoreAllFeatures: "すべての機能を復元",
    continueWithout: "続ける（機能は無効のまま）",
    allPremiumDetail:
      "プライベート写真を安全に整理するすべてのプレミアム機能へのアクセスを失います。",
    cloudVaultDetail:
      "クラウドバックアップが削除されます。デバイスを紛失または破損した場合、プライベート写真は永久に失われます。",
    cloudVaultDetailBold: "クラウドバックアップが削除されます。",
    cloudVaultDetailRest:
      "デバイスを紛失または破損した場合、プライベート写真は永久に失われます。",
    spaceSaverDetail:
      "写真がデバイスのストレージ容量をすべて使用します。保管庫の圧縮と最適化ができなくなります。",
    trashDetail:
      "誤って削除された写真は復元できません。一度削除されると永久に失われます。",
    noAdsDetail:
      "アプリ全体に広告が表示されるようになります。Premiumはすべての広告を削除し、中断のない体験を提供します。",
    decoyDetail:
      "おとりのパスコードが機能しなくなります。それを知っている人が本物の保管庫にアクセスできるようになります。",
    chooseYourPlan: "プランを選択",
    restoreFullProtection: "完全な保護を今すぐ復元",
    restorePremiumInstantly: "Premiumを今すぐ復元",
    restoreUltimateInstantly: "Ultimateを今すぐ復元",
    instantlyRestored: "即座に復元",
    reassurance:
      "中断したところからすぐに再開できます — サブスクリプション登録した瞬間にすべての機能が完全に復元されます。",
    subscribeAndRestore: "登録して復元",
    scrollForMore: "スクロールして詳細を表示",
    bestValue: "最もお得",
    switchToBasicDescription:
      "アプリ内の既存のすべての写真を引き続き表示・アクセスできます。アルバムとメディアはデバイス上で安全に保たれます。",
    viewAndAccess: "既存のすべての写真を表示・アクセス",
    premiumFeaturesDisabled: "",
    restorePremium: "Premiumを復元",
    restoreUltimate: "Ultimateを復元",
    choosePlanToReactivate: "すべての機能を再有効化するプランを選択",
    perMonth: "/月",
    twelveMonths: "年額",
    oneMonth: "1ヶ月",
  },
  backupPaywall: {
    title: "バックアップが有効ではありません",
    subtitle:
      "写真と動画がバックアップされていません。Premiumに登録してバックアップを有効にし、すべての機能をアンロックしましょう",
    subscribe: "Premiumを取得",
    cancelAnytime: "いつでもキャンセル可能",
  },
  lossAversion: {
    title: "バックアップされた写真は\n一枚もありません。",
    subtitle:
      "すべての写真はこの端末にのみ保存されています。紛失すると、永遠に失われます。",
    photosUnprotected: "未保護の\n写真",
    backedUp: "バックアップ済み",
    daysAtRisk: "危険な日数",
    backupCoverage: "バックアップ範囲",
    vaultProtected: (percent: number) =>
      `保管庫の${percent}%が保護されています`,
    premiumTitle: "Premiumで得られるもの",
  },
}
